// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 22H22V2H2V22ZM4 20V15H8V20H4ZM10 20V15H14V20H10ZM16 20V15H20V20H16ZM20 13H16V8H20V13ZM4 8H8V13H4V8ZM10 13V8H14V13H10Z"}}]};

const TableFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'table-filled',
    ref,
    icon: element,
  },
));

TableFilledIcon.displayName = 'TableFilledIcon';

export default TableFilledIcon;
